export default __webpack_public_path__ + "static/media/gen-failed.b994ebba.gif";